var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FFD324"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 7.49999C13.4 7.81825 13.2736 8.12347 13.0485 8.34852C12.8235 8.57356 12.5183 8.69999 12.2 8.69999C11.8817 8.69999 11.5765 8.57356 11.3515 8.34852C11.1264 8.12347 11 7.81825 11 7.49999C11 7.18173 11.1264 6.8765 11.3515 6.65146C11.5765 6.42642 11.8817 6.29999 12.2 6.29999C12.5183 6.29999 12.8235 6.42642 13.0485 6.65146C13.2736 6.8765 13.4 7.18173 13.4 7.49999Z",
    fill: "#454B53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2998 10.8V16.8C11.2998 17.0387 11.3946 17.2676 11.5634 17.4364C11.7322 17.6051 11.9611 17.7 12.1998 17.7C12.4385 17.7 12.6674 17.6051 12.8362 17.4364C13.005 17.2676 13.0998 17.0387 13.0998 16.8V10.8C13.0998 10.5613 13.005 10.3324 12.8362 10.1636C12.6674 9.99478 12.4385 9.89996 12.1998 9.89996C11.9611 9.89996 11.7322 9.99478 11.5634 10.1636C11.3946 10.3324 11.2998 10.5613 11.2998 10.8Z",
    fill: "#454B53"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.1d1ee9cc.svg";
export { ForwardRef as ReactComponent };